import type { ReactNode } from 'react';
import { Link } from '../lib/router';
import { Mark } from './Mark';

export function Masthead({ children }: { children?: ReactNode }) {
  return (
    <header className="masthead">
      <Link className="mark" to="/">
        <Mark title="Vortex" />
        <span>Vortex</span>
      </Link>
      <div className="masthead-meta">{children}</div>
    </header>
  );
}
